import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next';

const NotFound = () => {
    const backToHome = ()=>{
        window.location = "/"
    }
    const { t } = useTranslation();
    return (
        <main>
            <div className={'wrapper-loading'}>
                <div className={'main-container-content forbidden'}>
                    <div className='errors'>
                        <img alt='pageNotFound' src={require('../../assets/img/404.svg').default}
                        />
                        {/* <div className='title-error'>Xin lỗi, không tìm thấy trang bạn đang tìm kiếm</div> */}
                        <div className='title-error'> {t('noti.notFound')}</div>
                        <Button onClick={backToHome}>{t('noti.returnHome')}</Button>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default NotFound